import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-share",
  "use": "icon-icon-share-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-share\"><path d=\"M549.1712 926.9248a37.888 37.888 0 0 1-37.888-37.7856V659.1488C358.4 694.9888 222.6176 765.3376 126.2592 860.16a37.888 37.888 0 0 1-62.6688-38.1952A718.336 718.336 0 0 1 511.2832 358.4V134.8608a37.888 37.888 0 0 1 64.7168-26.7264l375.0912 376.832a37.7856 37.7856 0 0 1 0 53.248L576 915.8656a38.2976 38.2976 0 0 1-26.8288 11.0592z\" p-id=\"6103\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol